import Vue from "vue";
import VueRouter from "vue-router";
// import Home from '../views/Home.vue'

Vue.use(VueRouter);

const routes = [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: Home
  // },
  {
    path: "/",
    name: "course",
    icon: "el-icon-s-opportunity",
    showName: "課程/活動\n報名",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/course.vue"),
  },
  {
    path: "/course/:id",
    name: "courseDetail",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/courseForm.vue"),
  },
  {
    path: "/outpatient",
    name: "outpatient",
    icon: "el-icon-s-order",
    showName: "創業諮詢",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/outpatient.vue"),
  },
  {
    path: "/outpatient/:id",
    name: "outpatientDetail",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/outpatientForm.vue"),
  },
  {
    path: "/memberData",
    name: "memberData",
    icon: "el-icon-s-check",
    showName: "報名資料",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/memberData.vue"),
  },
  // {
  //   path: '/application',
  //   name: 'application',
  //   icon: "el-icon-s-flag",
  //   showName:"會員申請",
  //   component: () => import(/* webpackChunkName: "about" */ '../views/application.vue')
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
];

const router = new VueRouter({
  routes,
});

export default router;
